import { getSettings, getNextEvent, getNews, getEvents } from '../lib/data.js';
import { mediaUrl } from '../lib/supabase.js';
import { esc, formatDate, dayName, formatTime, monthLong } from '../lib/utils.js';
import { createCountdown } from '../components/countdown.js';

export async function renderUvod(view) {
    const [settings, nextEvent, news, events] = await Promise.all([
        getSettings(), getNextEvent(), getNews(3), getEvents()
    ]);

    const hero = mediaUrl(settings.hero_photo);
    const intro = settings.intro_text || '';
    const bandName = (settings.band_name || 'Amati Band').toString();

    // Odpočítávadlo se zobrazí jen když je nejbližší koncert méně než 14 dní
    // předem. Cíl = datum koncertu + čas začátku (default 18:00).
    let countdown = null;
    if (nextEvent) {
        const t = (nextEvent.time_start || '18:00').slice(0, 5);
        const targetIso = `${nextEvent.event_date}T${t}:00`;
        const daysUntil = (new Date(targetIso).getTime() - Date.now()) / 86400000;
        if (daysUntil < 14) {
            countdown = createCountdown(targetIso);
        }
    }

    view.innerHTML = `
        ${hero ? `
        <section class="hero">
            <img class="hero-photo" src="${esc(hero)}" alt="${esc(bandName)}">
        </section>` : ''}

        <div class="home-cols">
            <div class="home-right">
                <div class="home-intro">
                    <h1 class="home-band">${esc(bandName)}</h1>
                    <div class="hero-actions">
                        <a class="btn btn-primary" href="#/media">Poslechnout hudbu</a>
                        <a class="btn btn-ghost" href="#/poradatele">Pozvat na akci</a>
                    </div>
                    ${intro ? `<p class="intro-text">${esc(intro)}</p>` : ''}
                    ${countdown ? `
                    <div class="countdown-block">
                        <p class="eyebrow">Nejbližší vystoupení</p>
                        <h2 class="next-event">
                            ${esc(nextEvent.place_name || 'Koncert')}
                            <span class="next-event-date">${dayName(nextEvent.event_date)} ${formatDate(nextEvent.event_date)}${nextEvent.time_start ? ' · ' + formatTime(nextEvent.time_start) : ''}</span>
                        </h2>
                        <div id="countdown-host">${countdown.html}</div>
                    </div>` : ''}
                </div>

                <div class="home-block">
                    <h2 class="section-title">Kontakt</h2>
                    <div class="contact-card">
                        ${(settings.contact_name || settings.contact_phone || settings.contact_email) ? `
                            <ul class="contact-list">
                                ${settings.contact_name ? `<li>
                                    <span class="co-label">Kontaktní osoba</span>
                                    <span>${esc(settings.contact_name)}</span>
                                </li>` : ''}
                                ${settings.contact_phone ? `<li>
                                    <span class="co-label">Telefon</span>
                                    <a href="tel:${esc(settings.contact_phone.replace(/\\s/g, ''))}">${esc(settings.contact_phone)}</a>
                                </li>` : ''}
                                ${settings.contact_email ? `<li>
                                    <span class="co-label">E-mail</span>
                                    <a href="mailto:${esc(settings.contact_email)}">${esc(settings.contact_email)}</a>
                                </li>` : ''}
                            </ul>`
                        : '<p class="muted">Kontaktní údaje se brzy doplní.</p>'}
                    </div>
                </div>

                ${news.length ? `
                <div class="home-block">
                    <h2 class="section-title">Aktuality</h2>
                    <div class="news-list">
                        ${news.map((n) => newsItem(n)).join('')}
                    </div>
                    <div class="section-more">
                        <a class="btn btn-ghost" href="#/aktuality">Všechny aktuality</a>
                    </div>
                </div>` : ''}
            </div>

            <div class="home-left">
                <h2 class="section-title">Co nás čeká v roce ${new Date().getFullYear()}</h2>
                ${events.upcoming.length ? `
                    <ul class="event-list">
                        ${events.upcoming.map((e) => `
                            <li class="event-row">
                                <div class="event-date">
                                    <span class="ed-day">${new Date(e.event_date + 'T00:00:00').getDate()}.</span>
                                    <span class="ed-mon">${monthLong(e.event_date)}</span>
                                </div>
                                <div class="event-info">
                                    <strong>${esc(e.place_name || 'Koncert')}${e.city ? ', ' + esc(e.city) : ''}</strong>
                                    <span class="muted">${dayName(e.event_date)}${e.time_start ? ' · ' + formatTime(e.time_start) : ''}</span>
                                </div>
                            </li>`).join('')}
                    </ul>`
                : '<p class="empty">Nové termíny se brzy doplní — sledujte nás!</p>'}
            </div>
        </div>
    `;

    if (countdown) {
        countdown.mount(view.querySelector('#countdown-host'));
    }
}

function newsItem(n) {
    const date = (n.published_at || n.created_at || '').slice(0, 10);
    return `
        <a class="news-item" href="#/aktuality/${n.id}">
            <time>${formatDate(date)}</time>
            <h3>${esc(n.title)}</h3>
            <p>${esc(excerpt(n.body))}</p>
        </a>`;
}

function excerpt(text, len = 120) {
    const t = (text || '').replace(/\s+/g, ' ').trim();
    return t.length > len ? t.slice(0, len) + '…' : t;
}

